import { Reducer } from 'redux';
import { LazyLoadable } from '@mews-commander/ui';
import { MarketplaceContainerProps } from './components';

interface Exports {
    MarketplaceContainer: {
        marketplaceReducerKey: string;
        marketplaceReducer: Reducer;
        MarketplaceContainer: React.ComponentType<MarketplaceContainerProps>;
    };
}

export const LoadableMarketplaceContainer = LazyLoadable<MarketplaceContainerProps, Exports, {}>({
    loader: {
        MarketplaceContainer: async () => import(/* webpackChunkName: "marketplaceContainer" */ './loadable'),
    },
    render: (loaded, { injectReducer, dispatch, getState, ...other }) => {
        const { marketplaceReducerKey, marketplaceReducer, MarketplaceContainer } = loaded.MarketplaceContainer;
        injectReducer(marketplaceReducerKey, marketplaceReducer);

        return <MarketplaceContainer {...other} />;
    },
});
